import React, { useContext } from 'react';
import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Development from 'pages/development';
import ForgotPassword from 'pages/forgot-password';
import SignUp from 'pages/signup';
import ActivateAccount from 'pages/activate-account';
import Login from 'pages/login';
import { AuthContext } from 'context/authContext';
import ResetPassword from 'components/organisms/ResetPassword';
import Verification from 'pages/verification';
import SetPassword from 'components/organisms/SetPassword';
import Pages from './pages/index';
import ResendEmail from './pages/resend-email';

function PublicRoute({ isLoggedIn, redirectTo }) {
  return isLoggedIn ? <Navigate to={redirectTo} /> : <Outlet />;
}

function PrivateRoute({ isLoggedIn, redirectTo }) {
  return isLoggedIn ? <Outlet /> : <Navigate to={redirectTo} />;
}

function Router() {
  const { isLoggedIn, allowedPages } = useContext(AuthContext);
  return (
    <Routes>
      <Route path="/brand/:view" element={<PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn} />}>
        <Route path="/brand/:view" element={<Pages />} />
        <Route path="/brand/:view/:child" element={<Pages />} />
      </Route>
      <Route
        path="/sign-up"
        element={
          <PublicRoute
            isLoggedIn={isLoggedIn}
            redirectTo={allowedPages.length > 0 ? `/brand/${allowedPages[0]}` : '/brand/dashboard'}
          />
        }>
        <Route path="/sign-up" element={<SignUp />} />
      </Route>
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/set-password/:token" element={<SetPassword />} />
      <Route path="/development" element={<Development />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/resend-email" element={<ResendEmail />} />
      <Route path="/verification" element={<Verification />} />
      <Route
        path="*"
        element={
          <PublicRoute
            isLoggedIn={isLoggedIn}
            redirectTo={allowedPages.length > 0 ? `/brand/${allowedPages[0]}` : '/brand/dashboard'}
          />
        }>
        <Route path="*" element={<Login />} />
      </Route>
      <Route
        path="/activate-account"
        element={
          <PublicRoute
            isLoggedIn={isLoggedIn}
            redirectTo={allowedPages.length > 0 ? `/brand/${allowedPages[0]}` : '/brand/dashboard'}
          />
        }>
        <Route path="/activate-account" element={<ActivateAccount />} />
      </Route>
    </Routes>
  );
}

export default Router;
